// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JIaRz","col":"styles_col__3-_93"};